// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3rboz","productName":"Table_productName__N7LOB"};